exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.no-blend-mode[data-v-556d475f] {\n  mix-blend-mode: unset !important;\n  color: #000 !important;\n}\na.no-blend-mode[data-v-556d475f]:hover {\n  color: #DFA877 !important;\n}", ""]);

// exports
